import {
    AdminActivityResponse,
    AdminCenterResponse,
    AdminCompanyResponse,
    AdminDivisionResponse,
    AdminOpenMonthStatusResponse,
    AdminPersonResponse, AdminPersonsResponse, AdminPositionResponse, AdminPositionsResponse, AdminProductResponse, AdminProjectOrderResponse, AdminProjectResponse, AdminProjectsAndOrdersResponse, AdminQueryCenter, AdminQueryCompany,
    AdminQueryDivision,
    AdminQueryProject, AdminQueryPublicHoliday, UserLoginResponse, UserUnauthenticatedResponse
} from "../../backend/src/api/dto";

export default new class API {

    url: string;
    baseUrl: string;
    protocol: string;
    domain: string;


    constructor() {
        this.protocol = 'https://';
        this.domain = 'synchronix.mine.sk';

        switch (process.env.NODE_ENV) {
            case "production":
                this.baseUrl = this.protocol + this.domain
                this.url = '/api';
                break
            default:
                this.baseUrl = this.protocol + this.domain
                this.url = '/api'
        }
    }


    private post(url: string, data?: any) {
        return fetch(
            this.url + url,
            {
                method: 'POST',
                credentials: "include",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
        ).then(response => this.handleResponse(response))
    }



    private put(url: string, data: any) {
        return fetch(
            this.url + url,
            {
                method: 'PUT',
                credentials: "include",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
        ).then(response => this.handleResponse(response))
    }


    private delete(url: string) {
        return fetch(
            this.url + url,
            {
                method: 'DELETE',
                credentials: "include",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => this.handleResponse(response))
    }


    private get(url: string, data?: any) {
        return fetch(
            this.url + url + (data ? '?' + new URLSearchParams(data) : ''),
            {
                method: 'GET',
                credentials: "include",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }

            }
        ).then(response => this.handleResponse(response))
    }

    private async handleResponse(response: Response) {
        if (!response.ok) {
            if (response.status === 401 && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            throw await response.json()
        }
        const responseCopy = response.clone();
        return responseCopy.json().catch(e => {
            return response.text().then(res => {
                if (res === '') {
                    return null
                } else {
                    throw e
                }
            })

        })
    }

    getDownloadUrl(what: string) {
        return this.url + '/admin/download/' + what;
    }




    getChallenge() {
        return this.get('/user/challenge');
    }

    doLogin(login: string, challengeResponse: string): Promise<UserLoginResponse> {
        return this.post('/user/login', { login, challengeResponse });
    }

    getUser(): Promise<UserLoginResponse | UserUnauthenticatedResponse> {
        return this.get('/user');
    }

    doLogout() {
        return this.post('/user/logout');
    }

    setPassword(password: string) {
        return this.put('/user/password', { password });
    }

    /////////// shared


    userGetReporting(month: number | string | null, year: number | string | null) {
        return this.get('/user/reporting', { month, year });
    }

    userSetDay(timeReportRowId: number | string, day: number | string, hours: number | string, activityId: number | string) {
        return this.put('/user/reporting/day', { timeReportRowId, day, hours, activityId });
    }

    userSetDateRange(timeReportRowId: number | string, startDate: string, endDate: string, hours: number | string, activityId: number | string, overwrite: boolean) {
        return this.put('/user/reporting/date-range', { timeReportRowId, startDate, endDate, hours, activityId, overwrite });
    }

    userDeleteDay(timeReportRowId: number | string, day: number | string, activityId: number | string) {
        return this.delete('/user/reporting/day/' + timeReportRowId + '/' + day + '/' + activityId);
    }

    userInitVariables() {
        return this.get('/user/reporting/init');

    }

    monthActions(data: any) {
        return this.put('/user/reporting', data);

    }

    uploadData(what: string, data: any) {
        return this.post('/admin/upload/' + what, data)
    }

    sortOrder(what: string, data: any) {
        return this.put('/admin/sort/' + what, data)
    }

    getPublicHolidays(): Promise<AdminQueryPublicHoliday[]> {
        return this.get('/admin/public-holiday');
    }

    addPublicHoliday(name: string, day: number, month: number, func: string, fromYear: string, toYear: string) {
        return this.post('/admin/public-holiday', { name, day, month, function: func, fromYear, toYear });
    }

    setPublicHoliday(publicHolidayId: number | string, name: string, day: number, month: number, func: string, fromYear: string, toYear: string) {
        console.log({ name, day, month, function: func, fromYear, toYear })
        return this.put('/admin/public-holiday/' + publicHolidayId, { name, day, month, function: func, fromYear, toYear });
    }

    deletePublicHoliday(publicHolidayId: number | string) {
        return this.delete('/admin/public-holiday/' + publicHolidayId);
    }





    ///////////// admin ////////////

    getPMYearData(year?: string) {
        return this.get('/admin/pm-reporting/' + year);
    }
    setProjectMonthReport(timeReportRowId: number|string, obj: object) {
       return this.put('/admin/pm-reporting/'+timeReportRowId, obj)
    }
    getYearData(year?: string) {
        return this.get('/admin/reporting/' + year);
    }
    setDay(timeReportRowId: number, day: number, hours: number, activityId: number) {
        return this.put('/admin/reporting-day', { timeReportRowId, day, hours, activityId });
    }
    deleteDay(timeReportRowId: number, day: number, activityId: number) {
        return this.delete('/admin/reporting-day/' + timeReportRowId + '/' + day + '/' + activityId);
    }
    getPersonMonthReport(year: string, month: string, personId: string) {
        return this.get('/admin/reporting/' + year + '/' + month + '/person/' + personId);
    }
    createPersonMonthReport(year: string, month: string, personId: string) {
        return this.post('/admin/reporting/' + year + '/' + month + '/person/' + personId);
    }
    setPersonMonthReport(year: string, month: string, personId: string, status: number) {
        return this.put('/admin/reporting/' + year + '/' + month + '/person/' + personId, { status });
    }
    openMonth(year: number | string, month: number | string) {
        return this.post('/admin/reporting/' + year + '/' + month)
    }
    openMonthStatus(year: number | string, month: number | string): Promise<AdminOpenMonthStatusResponse[]> {
        return this.get('/admin/reporting/' + year + '/' + month + '/status')
    }
    getProjectMonthReport(year: string, month: string, projectId: string) {
        return this.get('/admin/reporting/' + year + '/' + month + '/project/' + projectId);
    }


    /* Person */
    getPersons(obj: object): Promise<AdminPersonsResponse> {
        return this.get('/admin/person', obj);
    }
    addPerson(personId: number | string, personData: {}) {
        return this.post('/admin/person', personData);
    }
    savePerson(personId: number | string, personData: {}) {
        return this.put('/admin/person/' + personId, personData);
    }
    setPersonPassword(personId: number | string, personData: { password: string }) {
        return this.put('/admin/person/' + personId + '/password', personData);
    }
    getPerson(personId: string | number): Promise<AdminPersonResponse> {
        return this.get('/admin/person/' + personId);
    }
    addPersonToProject(projectId: number | string, personId: number | string, startDate: string, endDate: string) {
        return this.post('/admin/project/' + projectId + '/person', {
            personId,
            startDate,
            endDate
        });
    }
    addPersonToOrder(projectId: number | string, orderId: number | string, personId: number | string, startDate: string, endDate: string) {
        return this.post('/admin/project/' + projectId + '/order/' + orderId + '/person', {
            personId,
            startDate,
            endDate
        });
    }
    removePersonFromOrder(projectId: number | string, orderId: number | string, personId: number | string) {
        return this.delete('/admin/project/' + projectId + '/order/' + orderId + '/person/' + personId)
    }
    deletePersonFromProject(projectId: number | string, personId: number | string) {
        return this.delete('/admin/project/' + projectId + '/person/' + personId);
    }
    addApproverToUser(personId: number | string, approverId: number | string) {
        return this.post('/admin/person/' + personId + '/approver', {
            approverId
        });
    }
    deleteApproverFromUser(personId: number | string, approverId: number | string) {
        return this.delete('/admin/person/' + personId + '/approver/' + approverId);
    }
    addOrderToUser(personId: number | string, orderId: number | string, startDate: string, endDate: string) {
        return this.post('/admin/person/' + personId + '/order', {
            orderId,
            startDate,
            endDate
        });
    }
    deleteOrderFromUser(personId: number | string, orderId: number | string) {
        return this.delete('/admin/person/' + personId + '/order/' + orderId);
    }
    getPersonReporting(personId: number | string) {
        return this.get('/admin/person/' + personId + '/reporting');
    }
    deletePerson(personId: number | string) {
        return this.delete('/admin/person/' + personId);
    }
    addManagerToProject(projectId: number | string, personId: number | string) {
        return this.post('/admin/project/' + projectId + '/manager', {
            personId
        });
    }
    deleteManagerFromProject(projectId: number | string, personId: number | string) {
        return this.delete('/admin/project/' + projectId + '/manager/' + personId);
    }



    /* Center */
    getCenters(): Promise<AdminQueryCenter[]> {
        return this.get('/admin/center');
    }
    getCenter(centerId: number | string): Promise<AdminCenterResponse> {
        return this.get('/admin/center/' + centerId);
    }
    addCenter(centerData: {}) {
        return this.post('/admin/center', centerData);
    }
    saveCenter(centerId: number | string, centerData: {}) {
        return this.put('/admin/center/' + centerId, centerData);
    }
    deleteCenter(centerId: number | string) {
        return this.delete('/admin/center/' + centerId);
    }


    /* Division */
    getDivisions(): Promise<AdminQueryDivision[]> {
        return this.get('/admin/division');
    }
    getDivision(divisionId: number | string): Promise<AdminDivisionResponse> {
        return this.get('/admin/division/' + divisionId);
    }
    addDivision(divisionData: {}) {
        return this.post('/admin/division', divisionData);
    }
    saveDivision(divisionId: number | string, divisionData: {}) {
        return this.put('/admin/division/' + divisionId, divisionData);
    }
    deleteDivision(divisionId: number | string) {
        return this.delete('/admin/division/' + divisionId);
    }


    /* Company */
    getCompanies(): Promise<AdminQueryCompany[]> {
        return this.get('/admin/company');
    }
    getCompany(companyId: number | string): Promise<AdminCompanyResponse> {
        return this.get('/admin/company/' + companyId);
    }
    addCompany(companyData: {}) {
        return this.post('/admin/company', companyData);
    }
    saveCompany(companyId: number | string, companyData: {}) {
        return this.put('/admin/company/' + companyId, companyData);
    }
    deleteCompany(companyId: number | string,) {
        return this.delete('/admin/company/' + companyId);
    }


    /* Position */
    getPositions(): Promise<AdminPositionsResponse> {
        return this.get('/admin/position');
    }
    getPosition(positionId: number | string): Promise<AdminPositionResponse> {
        return this.get('/admin/position/' + positionId);
    }
    addPosition(positionData: {}) {
        return this.post('/admin/position', positionData);
    }
    savePosition(positionId: number | string, positionData: {}) {
        return this.put('/admin/position/' + positionId, positionData);
    }
    deletePosition(positionId: number | string) {
        return this.delete('/admin/position/' + positionId);
    }


    /* Activity */
    getActivities() {
        return this.get('/admin/activity');
    }
    getActivity(activityId: number | string): Promise<AdminActivityResponse> {
        return this.get('/admin/activity/' + activityId);
    }
    addActivity(activityData: {}) {
        return this.post('/admin/activity', activityData);
    }
    saveActivity(activityId: number | string, activityData: {}) {
        return this.put('/admin/activity/' + activityId, activityData);
    }
    deleteActivity(activityId: number | string) {
        return this.delete('/admin/activity/' + activityId);
    }

    // getApprovers() {
    //     return this.get('/admin/approver');
    // }


    /* Product */
    getProducts() {
        return this.get('/admin/product');
    }
    getProduct(productId: number | string): Promise<AdminProductResponse> {
        return this.get('/admin/product/' + productId);
    }
    addProduct(productData: {}) {
        return this.post('/admin/product', productData);
    }
    saveProduct(productId: number | string, productData: {}) {
        return this.put('/admin/product/' + productId, productData);
    }
    deleteProduct(productId: number | string) {
        return this.delete('/admin/product/' + productId);
    }


    /* Order */
    getOrders() {
        return this.get('/admin/order');
    }
    addOrderToProject(projectId: number | string, name: string, description: string, withActivities: boolean, visible: boolean) {
        return this.post('/admin/project/' + projectId + '/order', {
            name,
            description,
            withActivities,
            visible
        });
    }
    saveProjectOrder(projectId: number | string, orderId: string | number, projectOrderData: {}) {
        return this.put('/admin/project/' + projectId + '/order/' + orderId, projectOrderData);
    }


    /* Project */
    getProjects(obj: object): Promise<AdminQueryProject[]> {
        return this.get('/admin/project', obj);
    }
    getProjectsAndOrders(obj: object): Promise<AdminProjectsAndOrdersResponse> {
        return this.get('/admin/project-order', obj);
    }
    getProject(projectId: string | number): Promise<AdminProjectResponse> {
        return this.get('/admin/project/' + projectId);
    }
    getProjectOrder(projectId: string | number, orderId: string | number): Promise<AdminProjectOrderResponse> {
        return this.get('/admin/project/' + projectId + '/order/' + orderId);
    }
    deleteProjectOrder(projectId: string | number, orderId: string | number) {
        return this.delete('/admin/project/' + projectId + '/order/' + orderId);
    }
    addProject(projectData: {}) {
        return this.post('/admin/project', projectData);
    }
    saveProject(projectId: number | string, projectData: {}) {
        return this.put('/admin/project/' + projectId, projectData);
    }
    deleteProject(projectId: number | string) {
        return this.delete('/admin/project/' + projectId);
    }








}